import { blue } from '@ant-design/colors';
import guardSound from '../../assets/audio/GP_Armor_Up_4.wav';
import potionSound from '../../assets/audio/GP_Heal_1.wav';
import endTurnSound from '../../assets/audio/GP_PutDown_2.wav';
import slashSound from '../../assets/audio/dagger-scrape-and-hit-185443.mp3';
import strikeSound from '../../assets/audio/sword-slash-and-swing-185432.mp3';
import cleaveSound from '../../assets/audio/sword-slash-with-a-designed-impact-185434.mp3';
import shieldBashSound from '../../assets/audio/sword-slash-with-metallic-impact-185435.mp3';
import { Button, Col, Divider, Progress, Row } from 'antd';
import { FC, useCallback, useMemo } from 'react';

import { useEnemyStore, useGameStore, useHeroStore } from '../store/game.store';
import { calculateHealthPercentage } from '../utils';

interface CombatCardProps extends React.PropsWithChildren {}
export const CombatCard: FC<CombatCardProps> = () => {
   const { getters } = useEnemyStore();
   const { gameActions } = useGameStore();
   const { state, actions } = useHeroStore();
   const { currentActionPoints, maxActionPoints, potionAvailable, currentGuardAmount } = state;
   const { heroicActions } = actions;
   const actionPointsPercentage = useMemo(() => calculateHealthPercentage({ currentHealth: currentActionPoints, maxHealth: maxActionPoints }), [currentActionPoints]);

   const handleSlash = useCallback(() => {
      new Audio(slashSound).play();
      gameActions.siggAttackEnemy({ attackType: 'Slash', enemyId: getters.getActiveTargetEnemy() });
   }, [gameActions, getters]);

   const handleStrike = useCallback(() => {
      new Audio(strikeSound).play();
      gameActions.siggAttackEnemy({ attackType: 'Strike', enemyId: getters.getActiveTargetEnemy() });
   }, [gameActions, getters]);

   const handleCleave = useCallback(() => {
      new Audio(cleaveSound).play();
      gameActions.siggAttackEnemy({ attackType: 'Cleave', enemyId: getters.getActiveTargetEnemy() });
   }, [gameActions, getters]);

   const handleDrinkPotion = useCallback(() => {
      new Audio(potionSound).play();
      heroicActions.drinkPotion();
   }, [heroicActions]);

   const handleGuard = useCallback(() => {
      new Audio(guardSound).play();
      heroicActions.guard();
   }, [heroicActions]);

   const handleShieldBash = useCallback(() => {
      new Audio(shieldBashSound).play();
      gameActions.siggBashesEnemy(getters.getActiveTargetEnemy());
      gameActions.siggAttackEnemy({ attackType: 'ShieldBash', enemyId: getters.getActiveTargetEnemy() });
   }, [gameActions, getters]);

   const handleEndTurn = useCallback(() => {
      new Audio(endTurnSound).play();
      heroicActions.resetActionPoints();
      gameActions.allEnemiesAttackSigg();
   }, [gameActions, heroicActions]);

   return (
      <div className='p-2'>
         <Row gutter={[16, 24]}>
            <Col span={8}>Action points</Col>

            <Col span={8}>
               <Progress
                  steps={maxActionPoints}
                  size={20}
                  percent={actionPointsPercentage}
                  strokeColor={blue[3]}
                  showInfo={false}
               />
            </Col>

            <Col span={8}></Col>
         </Row>


         <Row gutter={[16, 24]}>
            <Col span={8}>
               <p>1 AP</p>
            </Col>

            <Col span={8}>
               <p>2 AP</p>
            </Col>

            <Col span={8}>
               <p>3 AP</p>
            </Col>
         </Row>

         <Row gutter={[16, 24]}>
            <Col span={8}>
               <Button
                  type="primary"
                  onClick={handleSlash}
                  disabled={currentActionPoints < 1}
               >
                  Slash
               </Button>
            </Col>

            <Col span={8}>
               <Button
                  type="primary"
                  onClick={handleStrike}
                  disabled={currentActionPoints < 2}
               >
                  Strike
               </Button>
            </Col>

            <Col span={8}>
               <Button
                  type="primary"
                  onClick={handleCleave}
                  disabled={currentActionPoints < 3}
               >
                  Cleave
               </Button>
            </Col>
         </Row>

         <Row gutter={[16, 24]}>
            <Col span={8}>
               <Button
                  type="primary"
                  onClick={handleDrinkPotion}
                  disabled={potionAvailable <= 0 || currentActionPoints < 1}
               >
                  Drink potion x{potionAvailable}{' '}
               </Button>
            </Col>

            <Col span={8}>
               <Button
                  type="primary"
                  onClick={handleGuard}
                  disabled={currentActionPoints < 2 || currentGuardAmount > 0}
               >
                  Guard
               </Button>
            </Col>

            <Col span={8}>
               <Button
                  type="primary"
                  onClick={handleShieldBash}
                  disabled={currentActionPoints < 3}
               >
                  Shield Bash
               </Button>
            </Col>
         </Row>

         {currentActionPoints === 0 && (
            <Button
               type="primary"
               onClick={handleEndTurn}
            >
               End Turn
            </Button>
         )}
      </div>
   );
};
